export const environment = {
  production: false,
  bffAddress: '/api',
  authServiceDomain: 'https://okta-auth-cloudfront-qa.webo-test.alpaque.net',
  euAuthServiceAppId: 'blteface72519642681',
  usAuthServiceAppId: 'blt52d0b729dcd9b7f3',
  envName: 'qa',
  logSentryErrors: true,
};
